import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_HOST;

export type OffboardingStatus =
  | 'scheduled'
  | 'in_progress'
  | 'deactivated'
  | 'cancelled';

export type OffboardingChecklistItem = {
  id: string;
  title: string;
  owner: 'hr' | 'manager' | 'it' | 'employee';
  completed: boolean;
  completedAt?: string;
};

export type OffboardingRecord = {
  system: { id: string; company: string | number; user: string | number };
  details: {
    status: OffboardingStatus;
    reason?: string;
    lastWorkingDay: string;
    checklist: OffboardingChecklistItem[];
    initiatedBy: string | number;
    initiatedAt: string;
    deactivatedAt?: string;
    cancelledAt?: string;
  };
};

export async function startOffboarding(payload: {
  userId: string;
  lastWorkingDay: string;
  reason?: string;
  checklist?: OffboardingChecklistItem[];
}) {
  const { data } = await axios.post(`${API_HOST}/v1/offboarding`, payload);
  return data;
}

export async function listOffboardings(params?: {
  userId?: string;
  status?: OffboardingStatus;
}) {
  const { data } = await axios.get(`${API_HOST}/v1/offboarding`, { params });
  return data;
}

export async function updateOffboarding(
  id: string,
  payload: Partial<{
    status: OffboardingStatus;
    lastWorkingDay: string;
    reason: string;
    checklist: OffboardingChecklistItem[];
  }>,
) {
  const { data } = await axios.patch(`${API_HOST}/v1/offboarding/${id}`, payload);
  return data;
}

